(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-snp-release"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 860px)');

  // Staggered card reveal
  var cards = document.querySelectorAll('.asr-reveal');
  if ('IntersectionObserver' in window && !reduce.matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    cards.forEach(function (el) { io.observe(el); });
  } else {
    cards.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Scroll-driven zoom into the phone (Activity + Gene-Level Insights media)
  var zoomEls = document.querySelectorAll('[data-asr-zoom]');
  if (zoomEls.length && !reduce.matches) {
    var zooms = [];
    zoomEls.forEach(function (el) {
      zooms.push({
        el: el,
        base: el.querySelector('.asr-zoom__base'),
        closeup: el.querySelector('.asr-zoom__closeup')
      });
    });
    var ticking = false;

    function update() {
      ticking = false;
      zooms.forEach(function (z) {
        if (mobile.matches) {
          z.base.style.transform = '';
          if (z.closeup) z.closeup.style.opacity = 0;
          return;
        }
        var maxScale = z.closeup ? 0.5 : 0.16;
        var track = z.el.closest('.asr-sticky-split');
        var rect = track.getBoundingClientRect();
        var range = rect.height - z.el.offsetHeight;
        var p;
        if (range > 60) {
          // bottom-pinned sticky media: progress = how far we are through the travel
          var pinStart = window.innerHeight - 32 - z.el.offsetHeight;
          p = (pinStart - rect.top) / range;
        } else {
          // no sticky travel: progress = section's journey through the viewport
          p = (window.innerHeight * 0.85 - rect.top) / (rect.height + window.innerHeight * 0.5);
        }
        p = Math.min(1, Math.max(0, p));
        z.base.style.transform = 'scale(' + (1 + p * maxScale).toFixed(4) + ')';
        if (z.closeup) z.closeup.style.opacity = Math.min(1, Math.max(0, (p - 0.6) / 0.18)).toFixed(3);
      });
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // Sample report modal (ported from homepage v3)
  var modal = document.getElementById('asr-sample-modal');
  if (modal) {
    var setState = function (state) {
      modal.querySelectorAll('[data-asr-state]').forEach(function (el) {
        el.hidden = el.getAttribute('data-asr-state') !== state;
      });
    };
    var openModal = function (state) {
      setState(state);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var input = modal.querySelector('.asr-modal__input');
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (state === 'form' && input && finePointer) setTimeout(function () { input.focus(); }, 60);
    };
    var closeModal = function () {
      modal.hidden = true;
      document.body.style.overflow = '';
    };
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href="#sample"]');
      if (trigger) { e.preventDefault(); openModal('form'); return; }
      if (e.target.closest('[data-asr-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
    // Capture the email via AJAX so the lead is still tagged, then flip to thanks in place.
    var form = modal.querySelector('.asr-modal__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // Link this browser to the Klaviyo profile. klaviyo.js is loaded site-wide but
        // nothing else calls identify, so without this the visitor stays anonymous to
        // Klaviyo until they click a Klaviyo email or type their address at checkout —
        // which is why these leads never show up in browse or checkout abandonment.
        // Fires on submit, not on success, so it cannot affect the thank-you state.
        try {
          var kEmailEl = form.querySelector('input[type="email"]');
          var kEmail = kEmailEl && kEmailEl.value ? kEmailEl.value.trim() : '';
          if (kEmail) {
            window._learnq = window._learnq || [];
            window._learnq.push(['identify', { '$email': kEmail }]);
          }
        } catch (kErr) {}
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
        var done = function () { setState('thanks'); };
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
          .then(done, done);
      });
    }
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') openModal('thanks');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-hood-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Keep the page offset in sync with the bar's real height (mobile wraps taller).
    function syncHeight() {
      var bar = document.querySelector('[data-drhs]');
      var h = (bar && !bar.classList.contains('is-hidden')) ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--drhs-h', h + 'px');
      // Inline !important beats the theme's own body padding rules.
      document.body.style.setProperty('padding-top', h + 'px', 'important');
    }
    document.querySelectorAll('[data-drhs].drhs--dismissible').forEach(function (bar) {
      var key = 'drhs-dismissed-' + bar.id;
      try { if (sessionStorage.getItem(key)) { bar.classList.add('is-hidden'); } } catch (e) {}
      var btn = bar.querySelector('[data-drhs-close]');
      if (btn) btn.addEventListener('click', function () {
        bar.classList.add('is-hidden');
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        syncHeight();
      });
    });
    syncHeight();
    window.addEventListener('load', syncHeight);
    window.addEventListener('resize', syncHeight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-hood"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('.drh-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["genes-first-plan-release"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 860px)');

  // Scroll-driven zoom into the phone (Inside-the-plan media).
  // Adapted from activity-snp-release for TOP-pinned sticky media (top: 32px).
  var zoomEls = document.querySelectorAll('[data-gfp-zoom]');
  if (zoomEls.length && !reduce.matches) {
    var zooms = [];
    zoomEls.forEach(function (el) {
      zooms.push({ el: el, base: el.querySelector('.gfp-zoom__base') });
    });
    var ticking = false;

    function update() {
      ticking = false;
      zooms.forEach(function (z) {
        if (mobile.matches) { z.base.style.transform = ''; return; }
        var maxScale = 0.35;
        var track = z.el.closest('.gfp-sticky-split');
        var rect = track.getBoundingClientRect();
        var range = rect.height - z.el.offsetHeight;
        var p;
        if (range > 60) {
          // top-pinned sticky media: progress = how far the track has scrolled past the pin point
          p = (32 - rect.top) / range;
        } else {
          // no sticky travel: progress = section's journey through the viewport
          p = (window.innerHeight * 0.85 - rect.top) / (rect.height + window.innerHeight * 0.5);
        }
        p = Math.min(1, Math.max(0, p));
        z.base.style.transform = 'scale(' + (1 + p * maxScale).toFixed(4) + ')';
      });
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // Staggered card reveal
  var cards = document.querySelectorAll('.gfp-reveal');
  if ('IntersectionObserver' in window && !reduce.matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    cards.forEach(function (el) { io.observe(el); });
  } else {
    cards.forEach(function (el) { el.classList.add('is-in'); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
